<template>
  <browse-filter name="Plan type">
    <browse-filter-radio
      label="All plan types"
      name="plan_type"
      value="all"
      :checked="value === 'all'"
      @click="select"
    />
    <browse-filter-radio
      v-if="validTypes.includes('lifetime-deal') || validTypes.includes('one-time-purchase')"
      label="Lifetime deal"
      name="plan_type"
      value="lifetime-deal"
      :checked="value === 'lifetime-deal'"
      @click="select"
    />
    <browse-filter-radio
      v-if="validTypes.includes('limited-license')"
      label="Annual"
      name="plan_type"
      value="limited-license"
      :checked="value === 'limited-license'"
      @click="select"
    />
    <browse-filter-radio
      v-if="validTypes.includes('freebie')"
      label="Freebie"
      name="plan_type"
      value="freebie"
      :checked="value === 'freebie'"
      @click="select"
    />
    <browse-filter-radio
      v-if="validTypes.includes('subscription')"
      label="Subscription"
      name="plan_type"
      value="subscription"
      :checked="value === 'subscription'"
      @click="select"
    />
    <browse-filter-radio
      v-if="validTypes.includes('digital-download')"
      label="Digital download"
      name="plan_type"
      value="digital-download"
      :checked="value === 'digital-download'"
      @click="select"
    />
  </browse-filter>
</template>
<script>
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterRadio from './BrowseFilterRadio.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterRadio,
  },
  props: {
    value: {
      type: String,
      default: 'all',
    },
    planTypes: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
  computed: {
    validTypes() {
      return this.planTypes.map((type) => type.key);
    },
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
  },
};
</script>
